import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './Store';
import { appMessage } from './Actions';
import Messages from './Components/ComponentMessages';
import '../components/DocumentRegistrationForm';
import './Modules/Documents';
import './Modules/Notifications';
import './Modules/Values';
import './Reducer';
import './Modules/Account';
import '../components/ToggleMenu';
import '../components/ToggleNotifications';
import '../components/ScrollToAncher';
import '../components/Maintenance';
// If a fragment is set, it means the page will jump to an anchor on the page.
// Since the header is fixed ontop of the page, adjust for the height of the header.
if (window.location.hash) {
    window.scrollTo(0, $(document).scrollTop() - 100);
}
/**
 * Get any status messages from Symfony, by reading in the DOM.
 *
 * Each message will dispatch an appMessage.
 */
const applicationMessages = document.getElementById('application-messages');
if (applicationMessages) {
    let messages = applicationMessages.getAttribute('data-messages');
    if (messages.length) {
        messages = messages.split(';');
        messages.forEach((definition) => {
            if (definition.length) {
                const [severity, message] = definition.split(':');
                store.dispatch(appMessage(message, severity));
            }
        });
    }
    render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(Messages, {}) })), applicationMessages);
}
